import React, { Component } from "react";

import { EditorState, Modifier, ContentState, AtomicBlockUtils } from "draft-js";
import htmlToDraft from "html-to-draftjs";

import Icons from "customComponents/icons";

import * as CommonAction from "../../actions/commonAction";
import CommonStore from "../../stores/commonStore";
import UserInfoStore from "../../stores/userInfoStores";
import i18n from "../../i18nNext";

class FileUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileName: "file",
            fileWidth: "auto",
            fileHeight: "auto"
        };
        this._commonStoreChange = this._commonStoreChange.bind(this);
    }

    componentDidMount() {
        CommonStore.on("change", this._commonStoreChange);
    }

    componentWillUnmount() {
        CommonStore.removeListener("change", this._commonStoreChange);
    }

    _commonStoreChange(type) {
        if (type === "generatedS3Url") {
            let s3Url = CommonStore._getGeneratedS3Url().bill_urls[0];
            let fileName = s3Url.split("/");

            fileName = fileName[fileName.length - 1].split(".")[0];
            this.renderCustomContent(s3Url, fileName);
        }
    }

    renderCustomContent = (s3Url, fileName) => {
        // const { fileName } = this.state;
        const { editorState, onChange } = this.props;
        let extArr = ["png", "jpg", "jpeg"];
        let isImg = false;
        for (let i of extArr) {
            if (s3Url.includes(i)) {
                isImg = true;
            }
        }
        if (!isImg) {
            let data = `<a href=${s3Url} target="_blank">${fileName}</a>`;

            let { contentBlocks, entityMap } = htmlToDraft(data);
            const contentState = Modifier.replaceWithFragment(
                editorState.getCurrentContent(),
                editorState.getSelection(),
                ContentState.createFromBlockArray(contentBlocks, entityMap).getBlockMap()
            );

            onChange(EditorState.push(editorState, contentState, "insert-fragment"));
        } else {
            const stateAfterImgInsert = this.insertImage(s3Url);
            this.props.fileUploadReturnProps(stateAfterImgInsert);
        }
    };

    insertImage = url => {
        // const width = this.state.fileWidth > 375 ? "375px" : "auto";
        // const height = this.state.fileHeight > 200 ? "200px" : "auto";
        const { editorState } = this.props;
        const contentState = editorState.getCurrentContent();
        const contentStateWithEntity = contentState.createEntity("IMAGE", "IMMUTABLE", {
            src: url,
            alt: "Unable to display image. Please update Happay app!"
            // width,
            // // height
        });
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        const newEditorState = EditorState.set(editorState, {
            currentContent: contentStateWithEntity
        });
        return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, " ");
    };

    onFileChange = e => {
        e.target.removeEventListener("change", this.onFileChange);
        let file = e.target.files[0];

        const fileSize = file.size / (1024 * 1024);

        if (fileSize > 5) {
            UserInfoStore.showToast("Maximum allowed size for file upload at once is 5MB");
            return 0;
        }

        let reader = new FileReader();

        reader.readAsDataURL(file);

        if (file?.type === "application/pdf" || !/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(file.type)) {
            const reqData = new FormData();
            reqData.append("files", file, file.name);
            CommonAction.generateS3Url(reqData, "multipart/form-data");
        } else {
            reader.onload = () => {
                var img = new Image();
                img.onload = e => {
                    const reqData = new FormData();
                    reqData.append("files", file, file.name);
                    this.setState(
                        {
                            fileName: file.name,
                            fileWidth: e?.target?.width,
                            fileHeight: e?.target?.height
                        },
                        () => CommonAction.generateS3Url(reqData, "multipart/form-data")
                    );
                };
                img.src = reader.result;
            };
        }
        e.target.value = "";
    };

    hanldeClick = () => {
        // const elem = document.createElement("input");
        // elem.type = "file";
        // elem.addEventListener("change", e => this.onChange(e));
        // elem.click();
        const elem = document.getElementById("file-upload");
        elem.addEventListener("change", this.onFileChange);
        elem.click();
    };

    render() {
        return (
            <div className="rdw-image-wrapper" onClick={this.hanldeClick}>
                <div className="rdw-option-wrapper">
                    <Icons type="gallery" size="medium" title={i18n.t("lbl.attachFiles")} />
                    <input id="file-upload" type="file" style={{ display: "none" }} />
                </div>
            </div>
        );
    }
}

export default FileUpload;
